import { Injectable, inject } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";

import { Observable, Subject, timer } from "rxjs";

@Injectable({ providedIn: "root" })
export class CheckForUpdateService {
  private updates = inject(SwUpdate);

  private update$: Subject<boolean> = new Subject<boolean>();
  private hasInitialized = false;

  public get updateObservable(): Observable<any> {
    return this.update$.asObservable();
  }

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  init() {
    if (this.hasInitialized) {
      return;
    }
    const checkTimer$ = timer(5000, 60 * 1 * 1000);

    checkTimer$.subscribe(async () => {
      try {
        if (this.updates.isEnabled) {
          const updateFound = await this.updates.checkForUpdate();
          if (updateFound) {
            this.update$.next(true);
          }
        }
      } catch (err) {
        console.error("Failed to check for updates:", err);
      }
    });
    this.hasInitialized = true;
  }
}
